/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRoomGuests = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19 4H6v18H4V2h15z" />
        <path d="M12 13a4 4 0 0 1 4 4v2h-1v3H9v-3H8v-2a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2h1v3h2v-3h1a2 2 0 0 0-2-2zm7 0h-2v-2h2zm-7-9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 3h-2V6h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgRoomGuests as RoomGuests };
